import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

interface ClientPortalProps {
  children: React.ReactNode
}

const ClientPortal: React.FC<ClientPortalProps> = ({ children }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  if (!mounted) {
    return children
  }

  return createPortal(children, document.body)
}

export default ClientPortal
